var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9957 1.12305C4.82237 1.12305 2.57459 5.80749 2.57459 8.90416C2.57459 11.2186 2.91014 10.5375 1.62903 13.3608C0.064589 17.3842 6.3557 19.0286 9.9957 19.0286C13.6346 19.0286 19.9257 17.3842 18.3624 13.3608C17.0813 10.5375 17.4168 11.2186 17.4168 8.90416C17.4168 5.80749 15.1679 1.12305 9.9957 1.12305Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6903 22.1206C11.1803 23.8073 8.82474 23.8273 7.30029 22.1206",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.1c1eb5f815e4b4929e9bb213801652ba.svg";
export { ForwardRef as ReactComponent };